import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

export default {
  state: {
    currentProject: null,
    currentOnglet: null,
    listOnglet: [],
    data: null,
    style: null,
    metadata: null,
    currentBorderWidth: null,
    currentBorderColor: null,
    typeDonnees: null,
    projectsList: null,
    tableauxList: null,
    disabledAddTableau: false,
    espacesList: null,
    tableauDataById: null,
    showType: false,
    isProjectTemplate: false,
    isCopied: true,
    isCloningFormat: false,
    isSelectingColor: false
  },
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tableau/index.js